export default __webpack_public_path__ + "static/media/FindWork.2efc17ab.png";